export enum EScreenType {
  Default = 1,
  Report = 2,
  Master = 3,
  WebScreen = 4,
  Component = 5
}

export enum ESubScreenType {
  Default = 1,
  Workflow = 2
}
